/**
 * Client goi API.
 *
 * Khong dung axios va khong gan token: xac thuc di bang cookie phien cua
 * Django, va gateway phuc vu ca giao dien lan API tren cung mot goc nen
 * cookie tu dong di kem. `credentials: 'same-origin'` la tat ca nhung gi
 * can thiet.
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    /** Than phan hoi loi (JSON) — cho trang can them truong ngoai `message`. */
    readonly body?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api${path}`, {
    ...init,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      // FormData PHAI de trinh duyet tu dat Content-Type, vi header do con
      // phai kem `boundary` sinh ngau nhien; dat tay vao la may chu khong
      // tach duoc cac phan cua multipart.
      ...(init?.body && !(init.body instanceof FormData)
        ? { 'Content-Type': 'application/json' }
        : {}),
      ...init?.headers,
    },
  });

  if (res.status === 401 && !path.startsWith('/auth/login')) {
    // Dua ve trang dang nhap CUA STACK NAY, khong phai cua Django.
    // Giu lai duong dan hien tai de quay lai dung cho sau khi dang nhap.
    const here = window.location.pathname + window.location.search;
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = `/login?next=${encodeURIComponent(here)}`;
    }
    throw new ApiError(401, 'Phien dang nhap da het han.');
  }

  if (!res.ok) {
    let message = `Yeu cau that bai (${res.status}).`;
    let body: unknown;
    try {
      body = await res.json();
      const msg = (body as { message?: unknown } | null)?.message;
      if (Array.isArray(msg) ? msg.length : msg) message = String(msg);
    } catch {
      // Phan hoi khong phai JSON — giu thong bao mac dinh.
    }
    throw new ApiError(res.status, message, body);
  }

  return (await res.json()) as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(body) }),
  /**
   * Gui FormData (tep tai len).
   *
   * KHONG dat 'Content-Type': trinh duyet phai tu sinh header kem `boundary`,
   * dat tay vao la may chu khong tach duoc cac phan cua multipart.
   */
  postForm: <T>(path: string, form: FormData) =>
    request<T>(path, { method: 'POST', body: form }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};

export interface CurrentUser {
  id: number;
  username: string;
  email: string;
  fullName: string;
  isStaff: boolean;
  isSuperuser: boolean;
  permissions: string[];
}

export const fetchCurrentUser = () => api.get<CurrentUser>('/auth/me');
